<template>
  <div class="sjcj">
    <div class="card1">
      <div class="w1280">
        <div style="padding: 112px 0;">
          <div class="t11">智慧医疗</div>
          <div class="t22">
            专业医疗标注团队，HIPAA认证的医疗解决方案，支持人工智能医疗的多类型数据需求
          </div>
          <div class="btn1" style="margin: 0 auto;" @click="go('/callMe')">咨询方案</div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">专业智慧医疗数据服务</div>
    </div>
    <div class="w1280" style="margin: 48px auto;">
      <div class="flexs">
        <div style="width: 48%;">
          <img style="width: 100%;border-radius:16px" src="../assets/img/sjfw/yl1.webp" alt="">
        </div>
        <div style="width: 48%;">
          <div class="title-2">随着智慧医疗快速增长的需求，我们了解医疗医学细分行业对专业知识的需求，搭建专业团队服务客户的AI医疗数据需求。我们医学团队从项目经理到主管再到培训师，均为医学专业背景，具有多年临床经验，可以为客户提供全流程的专业把控；与此同时，各项目组还配备具有多年标注经验、管理过百人以上规模的项目管理人员，达到专业和管理的双向奔赴。</div>
          <ul>
            <li>近300名医学专业的全职AI数据训练师</li>
            <li>学科广泛覆盖临床医学、中医学、护理学、药学、医学心理学、健康管理学等</li>
            <li>4年多的医学项目实战积累，为行业内30余家客户、近500个医学项目提供专业的医学AI数据服务</li>
            <li>涉及医学大模型、医学文本、医学专业图像（放射医学、病理、消化内镜、心电图等）、医学语音/视频等各领域的专业数据训练和审核工作</li>
          </ul>
        </div>
        
      </div>
    </div>
    <div class="card2">
      <div class="title">应用场景：智慧医疗</div>
      
      <div class="w1280" style="margin-top:48px">
        <div class="flexs" style="flex-wrap: wrap;margin:0 128px" >
          <div class="card-sx" v-for="(item, index) in cardList" :key="index">
            <img
              style="width: 500px;height: 192px;border-radius:8px 8px 0 0;object-fit: cover; object-position: top;"
              :src="item.img"
              alt=""
            />
            <div class="contents">
              <div class="t1">{{ item.title }}</div>
              <div
                v-for="(item1, index1) in item.textList"
                :key="index1"
                class="t2"
              >
                {{ item1.title }}<span class="t3">{{ item1.content }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">医学数据服务能力</div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/v1.webp"
              alt=""
            />
          </div>
          <div style="width: 45%;">
            <div class="t1">医疗大模型服务</div>
            <div>我们拥有算法团队，以及我们大模型智能开发平台，助力医药领域大模型的构建，包括：</div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 50%;">
                <ul>
                  <li>医学、药学数据集构建</li>
                  <li>答案判断，排序，改写，打分等</li>
                  <li>CoT 标注及改写</li>
                  <li>RLHF 数据标注</li>
                  <li>Prompt Engineering 标注</li>
                  <li>RAG</li>
                  <li>大模型定制开发服务</li>
                </ul>
              </div>
              <div style="width: 50%;">
                
              </div>
            </div>
          </div>
          
        </div>
      </div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 45%;">
            <div class="t1">数据标注定制服务</div>
            <div>拥有百人全职标注员，以及1000+的医学、药学兼职标注人员，和医学背景项目负责人，已成功交付百余个医学、药学类数据标注项目：</div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 50%;">
                <ul>
                  <li>医学影像标注（放射，病理，心电图，胃肠镜等）</li>
                  <li>病历标注</li>
                  <li>医药数据库标注</li>
                  <li>医学内容审核</li>
                  <li>百科科普编辑/审核</li>
                </ul>
              </div>
              <div style="width: 50%;">
               
              </div>
            </div>
            
          </div>
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/v2.webp"
              alt=""
            />
          </div>
        </div>
      </div>
    
    </div>
    <div class="card2">
      <div class="title">我们的优势</div>
      <div class="w1280" style="">
        <div class="flexs" style="flex-wrap: wrap;margin:32px 128px">
          <div class="card-ys" v-for="(item, index) in ysList" :key="index">
            <img style="width:48px;height:48px;margin-bottom:8px" :src="item.img" alt="" />
            <div class="t1">{{item.name}}</div>
            <div class="t2">{{item.content}}</div>
          </div>
        </div>
      </div>
      </div>
    <div class="card-footer">
      <div class="t1">专业医疗AI数据服务</div>
      <div class="t2">专业医疗标注团队，HIPAA认证的医疗解决方案</div>
      <div class="btns" @click="go('/callMe')">联系我们</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ysList:[
        {
          name: "质量更高",
          content:
            "我们建立了同行评审质量保证工作流程与持续的测试和审核流程，并且我们还拥有资深的托管众包团队，负责数据的采集和标注。",
          img: require("../assets/img/sjfw/e1.svg"),
        },
        {
          name: "速度更快、规模更大",
          content:
            "我们提供 AI 辅助功能，如计算机视觉、命名实体识别、意图分类、NLP 信息提取、模型验证和再训练，以及查询结果关联等。",
          img: require("../assets/img/sjfw/e2.svg"),
        },
        {
          name: "安全优先的解决方案",
          content:
            "医疗保健公司相信我们可满足他们的数据需求并提供安全的服务。我们的安全设施已通过 ISO 27001 认证，我们的运营已通过 ISO 9001 认证，确保您的数据得到高效保护和质量控制。",
          img: require("../assets/img/sjfw/e3.svg"),
        },
        {
          name: "符合道德标准的 AI",
          content:
            "我们在全球有 100 万名众包资源帮助您开发无偏见的 AI；我们的《众包资源道德规范》以公平薪酬、包容、隐私和机密性为基础，是为众包人员创造福祉的关键。",
          img: require("../assets/img/sjfw/e4.svg"),
        },],
      cardList1: [
        {
          name: "数据存储与传输",
          list:[{t:'国安级加密云技术保证数据传输和存储安全'},{t:'业界领先的Appen Secure Workspace可确保在家办公环境达到与安全设备相同的安全级别'}],
          img: require("../assets/img/sjfw/x1.svg"),
        },
        {
          name: "项目现场与监管",
         list:[{t:'项目现场配置人脸识别和指纹门禁'},{t:'设有加密项目房间，仅授权人员准许进入 Secure Workspace可确保在家办公环境达到与安全设备相同的安全级别'},{t:'配有24*7值班人员以及无死角摄像头监控现场'}],
          img: require("../assets/img/sjfw/x2.svg"),
        },
        {
          name: "雇员与被采人管控",
          list:[{t:'标注人员及供应商签署保密协议'},{t:'全体员工办公设备均统一管理'}],
          img: require("../assets/img/sjfw/x3.svg"),
        }
      ],
      cardList: [
        {
          title: "医疗大模型",
          img: require("../assets/img/sjfw/j1.webp"),
          textList: [
            {
              title: "",
              content: "医疗健康垂类的大语言模型可以在三大方面提供强大的支持：在线医疗，智慧医院，以及医学研究。医疗大模型智能客服可以提高在线购药等功能的准确性和效率；通过智能诊断提高准确性和效率；并可整合医学知识和数据，帮助医生快速获取最新的医学信息和研究成果。",
            }
          ],
        },
        {
          title: "辅助诊断",
          img: require("../assets/img/sjfw/j2.webp"),
          textList: [
            {
              title: "",
              content: "医学影像器械的AI辅助诊断功能，涵盖放射医学影像，病理，心电图，胃肠镜等方面，可以给出检查结果的初步判断。同时，AI可以结合患者的症状描述、病史和检查结果，辅助医生进行诊断和制定治疗方案，提高诊断准确性和效率。",
            },
           
          ],
        },
        {
          title: "健康监测",
          img: require("../assets/img/sjfw/j3.webp"),
          textList: [
            {
              title: "",
              content:
                "AI支持的生物传感技术可以监测和分析生命体征数据，如心率、血压、血糖水平等，提供实时健康状态反馈；同时，可以根据个体的基因组数据和健康历史，为患者提供个性化的医疗方案和治疗建议。",
            }
          ],
        },
        {
          title: "医药数据库标注",
          img: require("../assets/img/sjfw/j4.webp"),
          textList: [
            {
              title: "",
              content:
                "对医学、药学文本内容进行清洗、分析、处理、判断、打标，建立研究数据库，为研究及建档提供强有力的内容支持。",
            }
          ],
        },
      ],
    };
  },
  methods: {
    go(path) {
      this.$router.push(path);
    }
  },
};
</script>
<style lang="scss" scoped>
.sjcj {
  .card1 {
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    width: 100%;
    height: 450px;
  }
  .card4 {
    width: 1280px;
    margin: 48px auto;
    text-align: center;
    .item-card2{
      flex-shrink: 0;
      text-align: center;
      width: 340px;
      margin: 40px 30px ;
    }
    .item-card {
      height: 240px;
      flex-shrink: 0;
      padding: 40px 24px;
      background-color: #eceff0;
      border-radius: 8px;
      width: 360px;
      margin-top: 20px;
      text-align: left;
      font-size: 16px;
    }
    .select-tab {
      margin: 30px 0 20px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 38px;
      line-height: 38px;
      align-content: center;
      padding: 2px;
      border-radius: 25px;
      border-width: 1px;
      border-style: solid;
      border-color: #000;
      border-image: initial;
      .s-tabs {
        width: 20%;
        height: 38px;
        text-align: center;
        cursor: pointer;
        border-radius: 25px;
      }
      .is-active {
        color: rgb(255, 255, 255);
        background: #045588;
      }
    }
    .card4-t1 {
      color: #045588;
      font-size: 48px;
      font-weight: bold;
    }
    .card4-t2 {
      font-size: 16px;
      width: 680px;
      margin: 24px auto 0;
      line-height: 1.5;
    }
    .card4-t3 {
      font-size: 32px;
      text-align: left;
      margin-bottom: 56px;
      color: #045588;
      font-weight: bold;
    }
    .btns {
      cursor: pointer;
      margin-top: 32px;
      width: 150px;
      background-color: #099fee;
      color: #fff;
      height: 48px;
      line-height: 48px;
      padding: 0 20px;
      border-radius: 8px;
    }
  }
  .card2 {
    width: 1280px;
    margin: 0 auto;
    .card-ys{
      width:448px;
      height:178px;
      padding: 24px;
      background-color: #eceff0;
      border-radius: 8px;
      margin-top:24px;
      .t1{
        font-size:20px;
        color: #25282a;
        margin-bottom: 16px;
      }.t2{
        font-size:16px;
        color: #25282a;
      }
    }
    .card-sx {
      width: 500px;

      margin: 0 0 48px;
      .contents {
        padding: 24px;
        height: 228px;
        background-color: #eceff0;
        border-radius: 0 0 8px 8px;
        .t1 {
          color: #045588;
          font-size: 24px;
          font-weight: 500;
          margin-bottom: 32px;
        }
        .t2 {
          color: #4b4f54;
          font-weight: bold;
          font-size: 16px;
          line-height: 1.5;
        }
        .t3 {
          font-weight: normal;
        }
      }
    }
    li {
      line-height: 1.5;
    }
    .t1 {
      color: #045588;
      font-size: 32px;
      margin-bottom: 16px;
      font-weight: 500;
    }
    .title {
      color: #045588;
      text-align: center;
      margin-top: 64px;
      font-weight: 500;
      font-size: 48px;
      margin-bottom: 8px;
    }
    .slogan {
      color: rgb(75, 79, 84);
      font-size: 16px;
      text-align: center;
      line-height: 1.2;
      width: 768px;
      margin: 0 auto 64px;
    }
  }
  .card-footer {
    width: 100%;
    height: 328px;
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    .t1 {
      color: rgb(0, 126, 204);
      font-weight: 500;
      font-size: 50px;
      text-align: center;
      padding-top: 60px;
    }
    .t2 {
      text-align: center;
      margin-top: 24px;
    }
    .btns {
      cursor: pointer;
      text-align: center;
      background-image: linear-gradient(
        260.38deg,
        #099fee 3.89%,
        #2247da 143.13%
      );
      width: 96px;
      height: 48px;
      padding: 0 16px;
      line-height: 48px;
      color: #fff;
      margin: 24px auto 0;
      border-radius: 8px;
    }
  }
  .btn1 {
    cursor: pointer;
    width: 250px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #fff;
    background-color: #099fee;
    border-radius: 8px;
  }
  .w1280 {
    width: 1280px;
    margin: 0 auto;
    .t11 {
      color: #045588;
      font-size: 56px;
      font-weight: bold;
      line-height: 84px;
      text-align: center;
    }
    .t22 {
      margin: 32px 256px;
      text-align: center;
      font-size: 20px;
      color: #4b4f54bf;
    }
    .title-1{
      color: #045588;
      font-size: 32px;
      margin-bottom: 16px;
    }
    .title-2{
      font-size:16px;
      line-height: 1.5;
    }
    li{
      margin-left: 24px;
      line-height: 1.5;
    }
  }
  .flexs {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
<style></style>
